export default {
  erase: '擦除',
  eraseComponent: '擦除组件',
  eraseSetting: '擦除设置',
  onlyOneTip: '同个场景内仅支持添加1个擦除组件。',
  isEnable: '组件是否启用',
  enableText: '启用',
  disableText: '禁用',
  brush: {
    title: '擦除笔触设置',
    brushStyle: '笔触样式',
    round: '圆形',
    rect: '矩形',
    pic: '图片识别',
    size: '尺寸',
    scale: '缩放比例',
    rotation: '旋转角度',
    picDesc: '图片文件：png, <1M',
    seqDesc: '序列帧文件：zip(png), <8M',
    addTip: '请选择图片以识别笔触样式',
    picTip: '可识别图片有效像素作为笔触',
    seqTip: '识别序列帧的第一帧作为笔触',
    handImage: '跟手图片',
    handImageTip: '擦除过程中跟随手指移动轨迹的擦除笔触图片',
    hangImageDialog: {
      title: '外观',
      pivot: '跟手锚点',
      pivotDesc: '绿点为笔触中心点<br/>可移动绿点调整笔触出现位置',
    },
  },
  layer: {
    title: '组件图层',
    maskLayer: '蒙层',
    bottomImage: '底图',
    eraseableTip:
      '此分组下，所有图片可被擦除。<br />可通过右侧开关控制默认启用还是禁用可被擦除，此处禁用后，可通过事件控制在特定时机下再启用',
    uneraseableTip: '此分组下，所有图片或动图不可被擦除',
    addGroup: '添加分组',
    groupName: '分组名称',
    groupNamePlaceholder: '请输入分组名称',
    groupNameEmptyWarning: '分组名称不能为空',
    eraseableTitle: '可不可以被擦除？',
    eraseable: '可被擦除',
    uneraseable: '不可擦除',
    applyAllAnimation: '应用到同层级的全部图层',
  },
  event: {
    title: '事件判定',
    when: '判断时机',
    upTrigger: '抬手时判定',
    erasingTrigger: '擦除过程实时判定',
    erasingTriggerTip: '该设置可能会引起性能问题，建议非必要不设置为该选项。',
    eraseTitleTip:
      '定义可被擦除区域被擦除到百分之几时，可触发事件；<br />完成设置后，进入事件选择到达或未到达某一阶段设定具体响应事件。',
    addEventJudge: '添加事件判定',
    areaSelectTitle: '判定区域选择',
    selectAreaPlaceholder: '请选择判定区域',
    addManageArea: '添加/管理自定义判定区域',
    addStep: '新增阶段',
    step: '阶段',
    stepWarning: '判定区域存在重复百分比，请修改或删除。',
    area: {
      title: '自定义判定区域',
      addArea: '添加自定义判定区域',
      editArea: '编辑自定义判定区域',
      areaName: '名称',
      areaNamePlaceholder: '请输入名称',
      addRect: '添加矩形',
      cancel: '取消',
      save: '保存',
    },
    stepSelect: '阶段选择',
    customEventPlaceholder: '请选择事件判定',
    stepPlaceholder: '请选择阶段',
    eraseStartTip: '在启用的可被擦除分组的图层上滑动，视为开始擦除',
    eraseUpTip: '开始擦除后抬手',
    eraseReachStepTip:
      '请先在擦除设置中设置好事件判定下对应的判定区域及阶段百分比',
    eraseUnReachStepTip:
      '请先在擦除设置中设置好事件判定下对应的判定区域及阶段百分比',
    addHandImage: '添加跟手图片',
    selectActionGroupPlaceholder: '请选择响应对象',
    selectHandImagePlaceholder: '请选择跟手图片',
    selectAnimationPlaceholder: '请选择动画',
  },
}
